import React, { useEffect, useState } from 'react';
import API, { getBranch, setBranch } from '../services/api';
import Icon from './Icon';
import './BranchSwitcher.css';

/**
 * Filial dəyişdirici — yalnız admin üçün.
 * Seçim localStorage-də saxlanılır və API interceptor onu X-Branch-Id
 * başlığı kimi göndərir. Dəyişiklikdən sonra səhifə yenilənir ki, bütün
 * açıq siyahılar yeni əhatə ilə yüklənsin.
 */
export default function BranchSwitcher({ role }) {
  const [branches, setBranches] = useState([]);
  const [open, setOpen]         = useState(false);
  const [current, setCurrent]   = useState(getBranch());

  useEffect(() => {
    if (role !== 'admin') return;
    let alive = true;
    API.get('/branches')
      .then(r => { if (alive) setBranches(r.data || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, [role]);

  // Admin deyilsə dəyişdirici göstərilmir — onların filialı sabitdir
  if (role !== 'admin' || branches.length < 2) return null;

  const label = current === 'all'
    ? 'Bütün filiallar'
    : (branches.find(b => String(b.id) === String(current))?.short_name || 'Filial');

  const pick = (val) => {
    setBranch(val);
    setCurrent(val);
    setOpen(false);
    window.location.reload();   // açıq siyahılar yeni əhatə ilə yüklənsin
  };

  return (
    <div className="bsw-wrap">
      <button type="button" className="bsw-btn" onClick={() => setOpen(o => !o)}
        title="Filial seçimi">
        <Icon name="building" size={16} />
        <span className="bsw-label">{label}</span>
        <Icon name="arrowRight" size={13} className="bsw-caret" />
      </button>

      {open && (
        <>
          <div className="bsw-backdrop" onClick={() => setOpen(false)} />
          <div className="bsw-menu">
            <button type="button"
              className={'bsw-item' + (current === 'all' ? ' active' : '')}
              onClick={() => pick('all')}>
              <span className="bsw-item-name">Bütün filiallar</span>
              {current === 'all' && <Icon name="check" size={14} />}
            </button>
            <div className="bsw-sep" />
            {branches.map(b => (
              <button key={b.id} type="button"
                className={'bsw-item' + (String(current) === String(b.id) ? ' active' : '')}
                onClick={() => pick(String(b.id))}>
                <span className="bsw-item-name">{b.short_name || b.name}</span>
                <span className="bsw-item-n">{b.user_count}</span>
                {String(current) === String(b.id) && <Icon name="check" size={14} />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
